import type { TOC } from '@ember/component/template-only';
import { assert } from '@ember/debug';
import { trustHTML } from '@ember/template';
import { ICONS_BRANDS_MAP } from '@mylighthouse/prism-foundation';

import type { IconBrandName } from '../../types/components/prism/icon-brand.ts';
import { UNIQUE_ID, uniqueId } from '../../utils/unique-id.ts';

function getSvgCode(iconBrandName: IconBrandName): string {
  let svgCode = ICONS_BRANDS_MAP[iconBrandName];

  assert(`Icon "${iconBrandName}" does not exist`, svgCode);

  if (svgCode === undefined) {
    return '';
  }

  /*
   * Make sure that multiple SVGs on the same page don't collide with each other
   * by replacing the hardcoded prefix (see svgo config files) with a unique one.
   */
  svgCode = svgCode.replaceAll(UNIQUE_ID, uniqueId());

  return svgCode;
}

interface PrismIconBrandSignature {
  Args: {
    name: IconBrandName;
  };
}

const PrismIconBrand: TOC<PrismIconBrandSignature> = <template>
  <span class="prism-icon-brand">
    {{trustHTML (getSvgCode @name)}}
  </span>
</template>;

export default PrismIconBrand;

export type { IconBrandName };
